import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {updateDocument, type UpdateDocumentRequest, type UpdateDocumentResponse} from '../../http';

export function useUpdateDocument(
	options?: UseMutationOptions<UpdateDocumentResponse, AxiosError, UpdateDocumentRequest>,
): UseMutationResult<UpdateDocumentResponse, AxiosError, UpdateDocumentRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateDocumentResponse, AxiosError, UpdateDocumentRequest>(
		(request) => updateDocument(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
